import { Component, Input, ViewChild , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalDirective } from "../../directives/modal.directive";
import { IItemDetail } from "../../interfaces/iitemconfig";


@Component({
    selector: "htmlcontentmodal",
    templateUrl: "./htmlcontentmodal.component.html",
    standalone: true,
    imports: [CommonModule, ModalDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HtmlContentModalComponent {
    @Input() originalItem: IItemDetail;
    @Input() currentItem: IItemDetail;

    @ViewChild("htmlcontentmodal") public htmlContentModal: ModalDirective;

    openModal(): void {
      this.htmlContentModal.show();
    }

    closeModal(): void {
       this.htmlContentModal.hide();
    }
}




